import { makeAutoObservable, runInAction } from "mobx";

import { deleteInvite, resendInvite, type Invite } from "@/api";

export class InviteApi {
  inviteData: Invite;

  constructor(inviteData: Invite) {
    this.inviteData = inviteData;
    makeAutoObservable(this);
  }

  async revoke() {
    const { invite } = await deleteInvite(this.inviteData.token);
    if (invite) {
      runInAction(() => {
        this.inviteData = invite;
      });
    }
    return invite;
  }

  async resend() {
    const { invite } = await resendInvite(this.inviteData.token);
    if (invite) {
      runInAction(() => {
        this.inviteData = invite;
      });
    }
    return invite;
  }
}
